import PropTypes from 'prop-types'

import { idPropType } from '../../common/prop-types'

const dictionaryWordPropType = PropTypes.shape({
  id: idPropType.isRequired,
  term: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  source: PropTypes.string,
  languageId: PropTypes.string,
  updatedBy: idPropType,
})

export default dictionaryWordPropType
